module.exports = __webpack_public_path__ + "models/bird_06707268e8e96a68918c484cca9efcb4.glb";